import { actionTypes as dataFetchActionTypes } from '@bufferapp/async-data-fetch';
import { actions as analyticsActions } from '~/analytics-middleware/actions';
import {
  getPageNameFromPath,
  getChannelIfNeeded,
} from '~/analytics-middleware/utils/Pathname';
import { LOCATION_CHANGE } from 'connected-react-router';
import zendeskWidget from './zendesk-widget';

import { actionTypes } from './reducer';

export default ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    next(action);
    switch (action.type) {
      case `user_${dataFetchActionTypes.FETCH_SUCCESS}`: {
        dispatch({ type: actionTypes.BUGSNAG, result: action.result });
        dispatch({ type: actionTypes.ZENDESK_WIDGET, result: action.result });

        break;
      }

      case actionTypes.BUGSNAG:
        if (window && window.bugsnagClient) {
          window.bugsnagClient.user = {
            id: action.result.id,
            adminLink: `https://buffer.com/admin/user/${action.result.id}`,
          };
        }
        break;

      case actionTypes.ZENDESK_WIDGET:
        if (window && window.zE) {
          const { name, email } = action.result;
          zendeskWidget.init();
          zendeskWidget.prefillWidgetForm(name, email);

          dispatch({
            type: actionTypes.ZENDESK_WIDGET_LOADED,
            loaded: true,
          });
        }
        break;

      case LOCATION_CHANGE: {
        const path = action.payload.location.pathname;
        /* when a user first hits publish.buffer.com, we select a profile for them and the routes changes
       We don't want to track the initial load before the profile is selected */
        if (path !== '/') {
          const metadata = {
            platform: 'new_publish',
            product: 'publish',
            name: getPageNameFromPath(path) || null,
            path,
            title: document.title || null,
            url: window.location.origin || null,
            referrer: document.referrer || null,
            search: action.payload.search || null,
            // don't need channel if route isnt associated with profileId
            channel: getChannelIfNeeded({ path, getState }),
          };
          dispatch(analyticsActions.trackEvent('Page Viewed', metadata));
        }
        break;
      }
      default:
        break;
    }
  };
